<template>
  <v-container class="summary-view-container">
    <v-row class="full-height">
      <v-col class="px-0 full-height d-flex justify-center">
        <EcsSummaryView />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EcsSummaryView from '@/components/ecs-summary-view/EcsSummaryView';
export default {
  name: 'Summary',
  components: { EcsSummaryView }
};
</script>

<style scoped>
.summary-view-container {
  max-width: none;
  height: calc(100vh - 64px);
}
.summary-view-container .full-height {
  overflow-y: scroll;
}
</style>
